import { Event, Interface, Method } from '@central-products/transport-bus-common';
import { ObSessionStatePayload } from './interfaces';
import { ObSessionStateType } from './enums';

export interface OnStateChangedPayload {
  state: ObSessionStateType;
}

export type OnStateChangedCallback = (payload: OnStateChangedPayload) => void;

@Interface('common', 'obsession')
export class ObSessionServiceInterface {
  @Event('state.changed')
  // @ts-ignore
  public onStateChanged(callback: (payload: ObSessionStatePayload) => void): void {
    throw new Error('Event is not implemented yet');
  }

  @Method('state.get')
  public getState(): Promise<ObSessionStatePayload> {
    throw new Error('Method is not implemented yet');
  }

  @Method('await.logged.in')
  public awaitLoggedIn(): Promise<{}> {
    throw new Error('Method is not implemented yet');
  }
}
